export default {
	"components.GotIt": "知道了",
	"components.OrderDetails": "订单详情",
	"components.ActivateTheContent": "激活内容",
	"components.NoActivationAddress": "无激活地址！",
	"components.TheActivationCodeIsInvalid": "激活码失效",
	"components.TheActivationCodeIsInvalidEnteringTheActivationCodemaxErrorTimesTimesTheInvalidActivationCodeAccountWillBeLockedYouCurrentlyHavefailedTimesTimes": "该激活码无效， 输入激活码{maxErrorTimes}次无效激活码账户将被锁定，你当前还有{failedTimes}次机会",
	"components.YouveAlreadyUsedTheActivationCode": "你已使用过该激活码",
	"components.ClickOrderDetailsToViewTheOrderInformationOrYouCanActivateItInTheContentToBeActivated": "点击【订单详情】查看订单信息，也可以在待激活内容中去激活",
	"components.TheItemHasBeenRemovedFromTheShelves": "该商品已下架",
	"components.TheActivationCodeRedeemableGoodsHaveBeenRemovedFromTheShelvesAndCannotBeRedeemedIfYouHaveAnyQuestionsPleaseContactCustomerServiceToDealWithIt": "该激活码可兑换的商品已下架，无法进行兑换，如有疑问请联系客服处理",
	"components.TheActivationCodeIsAlreadyInUse": "该激活码已使用",
	"components.TheActivationCodeHasExpired": "该激活码已过期",
	"components.TheAccountHasBeenLocked": "该账户已被锁定",
	"components.TheNumberOfTimesYouEnterTheWrongActivationCodeHasReachedTheUpperLimitTheAccountIsTemporarilyLockedTheLockDurationlockTimeDescIfYouHaveAnyQuestionsPleaseContactCustomerServiceToDealWithIt": "你输入错误激活码次数已达上限，账户暂被锁定，锁定时长{lockTimeDesc}，如有疑问请联系客服处理",
	"components.TheActivationCodeIsLoggedOut": "该激活码已注销",
	"components.TheActivationCodeIsNotYetValid": "该激活码还未生效",
	"components.TheActivationDidNotTakeEffectAtTheTimeOfEntryeffectiveDate": "该激活未到生效时间，生效时间为：{effectiveDate}",
	"components.TheItemIsNotYetInEffect": "该商品还未生效",
	"components.TheProductHasNotYetReachedTheEffectiveTimeTheEffectiveTimeIseffectiveDate": "该商品还未到生效时间，生效时间为：{effectiveDate}",
	"components.YouveAlreadyRedeemedTheItem": "你已兑换过该商品",
	"components.TheItemHasBeenRedeemed": "该商品已兑换",
	"components.TheProductHasBeenRemovedFromTheShelvesAndCannotBeRedeemedIfYouHaveAnyQuestionsPleaseContactCustomerServiceToDealWithIt": "该商品已下架，无法进行兑换，如有疑问请联系客服处理",
	"components.PleaseUseTheMainAccountOfTheAffectionNumberToRedeemTheContent": "请使用亲情号主账号兑换内容",
	"components.YouArePrompted": "系统提示",
	"components.FailedToRedeemTheItem": "兑换商品失败！",
	"components.SorryYouDoNotMeetTheNewUserPurchaseRulesPleaseGoToTheLoveToReadPublicAccountToBuyAfterRefund": "抱歉，您不满足新用户购买规则，请退款后前往“爱阅读的叫叫”公众号购买",
	"components.FailedToRedeemActivationCode": "兑换激活码失败"
}